var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1286 8.34296H17.6857V6.78582H16.1286V8.34296Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1286 13.0144H17.6857V11.4573H16.1286V13.0144Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4571 2.11439V0.557251H8.34284V2.11439H11.4571Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34284 3.67154V2.11439H5.22856V3.67154H8.34284Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22856 5.22868V3.67154H2.11427V5.22868H5.22856Z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11427 5.22868H0.557129V14.5715H2.11427V5.22868Z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11427 14.5715V16.1287H5.22856V14.5715H2.11427Z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22856 16.1287V17.6858H8.34284V16.1287H5.22856Z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34284 17.6858V19.243H11.4571V17.6858H8.34284Z",
    fill: ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4571 17.6858H13.0143V2.11439H11.4571V17.6858Z",
    fill: ""
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2428 8.34296H17.6857V11.4573H19.2428V8.34296Z",
    fill: ""
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 8.34291H23.9141V6.78577H22.3569V8.34291Z",
    fill: ""
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 13.0143H23.9141V11.4572H22.3569V13.0143Z",
    fill: ""
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4712 8.34291H23.9141V11.4572H25.4712V8.34291Z",
    fill: ""
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 5.22229,
    width: 1.55556,
    height: 1.55556,
    fill: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7778,
    y: 3.66675,
    width: 1.55556,
    height: 1.55556,
    fill: ""
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 13.0001,
    width: 1.55556,
    height: 1.55556,
    fill: ""
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7778,
    y: 14.5557,
    width: 1.55556,
    height: 1.55556,
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.62197ad9.svg";
export { ForwardRef as ReactComponent };